var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-10"},[_c('CustomerAddHeader'),_c('CustomerAddForm')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }